export const ERRORS = {
    AFTER_CUTOFF: 'Нельзя отправить заявку после 22:00',
    PHONE_INVALID: 'Номер введён некорректно',
    BOXES_INVALID: 'Коробки заполнены некорректно',
};

export const DOC_NAMES = {
    REGULATIONS: 'Условия и положения',
    OFERTA: 'Договор-оферта',
    PRIVACY: 'Политика конфиденциальности',
};

export const PAYMENT = {
    ONLINE: 'Онлайн на сайте',
    OFFICE: 'В офисе',
};
